<template>
  <div class="maintaining">
    <div class="head">
      <img
        src="https://s3.ap-northeast-1.amazonaws.com/media.web.pgebet.com/common/maintenanceTool.png"
        alt="maintainTool"
      />
    </div>
    <div class="notice">
      <p>
        {{ $t('lang.maintenance.dearPlayer') }}
      </p>
      <p>
        {{ $t('lang.maintenance.pleaseWait') }}
      </p>
      <p>
        {{ $t('lang.maintenance.thankYou') }}
      </p>
    </div>
  </div>
</template>

<script>

export default {
  name: 'maintaining',
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style lang="less" scoped>
  .maintaining {
    .head {
      display: flex;
      justify-content: center;
      width: 100%;

      img {
        width: 50vw;
        margin: 10vw 5vw;
      }
    }

    .notice {
      padding: 16px;

      p {
        font-size: 24px;
        color: #f6ead4;
        font-weight: 700;
        line-height: 32px;
        text-decoration: underline;
        text-transform: capitalize;
        margin-bottom: 16px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Maintaining/index.vue